import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo, useCallback } from 'react';
import { useMemberActions } from '@poplar/contexts/MemberActionsProvider';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { TodosPageSmall } from './TodosPageSmall';
import { TodosPageLarge } from './TodosPageLarge';
import { FeedbackFlyout } from '@poplar/components/tasks/Feedback/Flyout';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { API_TASKS } from '@poplar/constants/routes';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { useFeedbackToast } from '@poplar/hooks/useFeedbackToast';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var hasNotification = function hasNotification(actionItems, tasksData) {
  if (!(tasksData !== null && tasksData !== void 0 && tasksData.data)) return false;
  return tasksData.data.some(function (taskPage) {
    if (!(taskPage !== null && taskPage !== void 0 && taskPage.tasks)) return false;
    return taskPage.tasks.some(function (task) {
      return !!actionItems.find(function (actionItem) {
        return actionItem.taskId === task.taskId;
      });
    });
  });
};

var TodosPageV2 = function TodosPageV2(_ref) {
  var _dataInProgress$data, _dataInProgress$data$, _dataInProgress$data$2, _dataCompleted$data, _dataCompleted$data$, _dataCompleted$data$$, _dataUpcoming$data, _dataUpcoming$data$, _dataUpcoming$data$$t, _feedbackState$taskFe2;

  var dataCompleted = _ref.dataCompleted,
      dataDraft = _ref.dataDraft,
      dataUpcoming = _ref.dataUpcoming,
      dataInProgress = _ref.dataInProgress,
      feedbackCategories = _ref.feedbackCategories;

  var _useState = useState({
    taskFeedback: null,
    initialRating: 0,
    visible: false
  }),
      feedbackState = _useState[0],
      setFeedbackState = _useState[1];

  var _useTasks = useTasks(),
      openDeleteTaskModal = _useTasks.actions.openDeleteTaskModal;

  var _useState2 = useState(false),
      isDeletingBookmark = _useState2[0],
      setIsDeletingBookmark = _useState2[1];

  var _useFeedbackToast = useFeedbackToast(function (taskFeedback, initialRating) {
    setFeedbackState({
      taskFeedback: taskFeedback,
      initialRating: initialRating,
      visible: true
    });
  }),
      dismissPrompt = _useFeedbackToast.dismissPrompt,
      isError = _useFeedbackToast.isError,
      isFetchSuccessful = _useFeedbackToast.isFetchSuccessful;

  var handleCloseFeedbackFlyout = function handleCloseFeedbackFlyout() {
    var _feedbackState$taskFe;

    setFeedbackState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        visible: false
      });
    });

    if ((_feedbackState$taskFe = feedbackState.taskFeedback) !== null && _feedbackState$taskFe !== void 0 && _feedbackState$taskFe.taskId && !isError && isFetchSuccessful) {
      void dismissPrompt(feedbackState.taskFeedback.taskId);
    }
  };

  var onDeleteExpiredBookmark = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(task) {
      var getTaskResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsDeletingBookmark(true);
              _context.next = 4;
              return fetchJson("".concat(API_TASKS, "/").concat(task.taskId));

            case 4:
              getTaskResponse = _context.sent;
              openDeleteTaskModal(getTaskResponse.task);

            case 6:
              _context.prev = 6;
              setIsDeletingBookmark(false);
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0,, 6, 9]]);
    }));

    return function onDeleteExpiredBookmark(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useMemberActions = useMemberActions(),
      actionItems = _useMemberActions.state.actionItems;

  var hasDraftNotification = useMemo(function () {
    return hasNotification(actionItems, dataDraft);
  }, [actionItems, dataDraft]);
  var hasInProgressNotification = useMemo(function () {
    return hasNotification(actionItems, dataInProgress);
  }, [actionItems, dataInProgress]);
  var hasCompletedNotification = useMemo(function () {
    return hasNotification(actionItems, dataCompleted);
  }, [actionItems, dataCompleted]);
  var hasUpcomingNotification = useMemo(function () {
    return hasNotification(actionItems, dataUpcoming);
  }, [actionItems, dataUpcoming]);
  var sectionIndicators = useMemo(function () {
    return {
      draft: hasDraftNotification,
      inProgress: hasInProgressNotification,
      completed: hasCompletedNotification,
      upcoming: hasUpcomingNotification
    };
  }, [hasDraftNotification, hasInProgressNotification, hasCompletedNotification, hasUpcomingNotification]);
  var showGettingStarted = (dataInProgress === null || dataInProgress === void 0 ? void 0 : (_dataInProgress$data = dataInProgress.data) === null || _dataInProgress$data === void 0 ? void 0 : (_dataInProgress$data$ = _dataInProgress$data[0]) === null || _dataInProgress$data$ === void 0 ? void 0 : (_dataInProgress$data$2 = _dataInProgress$data$.tasks) === null || _dataInProgress$data$2 === void 0 ? void 0 : _dataInProgress$data$2.length) === 0 && (dataCompleted === null || dataCompleted === void 0 ? void 0 : (_dataCompleted$data = dataCompleted.data) === null || _dataCompleted$data === void 0 ? void 0 : (_dataCompleted$data$ = _dataCompleted$data[0]) === null || _dataCompleted$data$ === void 0 ? void 0 : (_dataCompleted$data$$ = _dataCompleted$data$.tasks) === null || _dataCompleted$data$$ === void 0 ? void 0 : _dataCompleted$data$$.length) === 0 && (dataUpcoming === null || dataUpcoming === void 0 ? void 0 : (_dataUpcoming$data = dataUpcoming.data) === null || _dataUpcoming$data === void 0 ? void 0 : (_dataUpcoming$data$ = _dataUpcoming$data[0]) === null || _dataUpcoming$data$ === void 0 ? void 0 : (_dataUpcoming$data$$t = _dataUpcoming$data$.tasks) === null || _dataUpcoming$data$$t === void 0 ? void 0 : _dataUpcoming$data$$t.length) === 0;
  var openFeedbackFlyout = useCallback(function (taskFeedback, initialRating) {
    setFeedbackState({
      taskFeedback: taskFeedback,
      initialRating: initialRating,
      visible: true
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
      children: /*#__PURE__*/_jsx(TodosPageSmall, {
        dataCompleted: dataCompleted,
        dataDraft: dataDraft,
        dataInProgress: dataInProgress,
        dataUpcoming: dataUpcoming,
        showGettingStarted: showGettingStarted,
        isDeletingBookmark: isDeletingBookmark,
        sectionIndicators: sectionIndicators,
        openFeedbackFlyout: openFeedbackFlyout,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark
      })
    }), /*#__PURE__*/_jsx(RenderOn.Tablet, {
      children: /*#__PURE__*/_jsx(TodosPageLarge, {
        dataCompleted: dataCompleted,
        dataDraft: dataDraft,
        dataInProgress: dataInProgress,
        dataUpcoming: dataUpcoming,
        showGettingStarted: showGettingStarted,
        sectionIndicators: sectionIndicators,
        isDeletingBookmark: isDeletingBookmark,
        openFeedbackFlyout: openFeedbackFlyout,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark
      })
    }), /*#__PURE__*/_jsx(FeedbackFlyout, {
      taskFeedback: feedbackState.taskFeedback,
      isOpen: feedbackState.visible,
      feedbackCategories: feedbackCategories,
      initialRating: feedbackState.initialRating,
      onClose: handleCloseFeedbackFlyout,
      onSubmitted: function onSubmitted() {
        void dataCompleted.mutate();
      }
    }, (_feedbackState$taskFe2 = feedbackState.taskFeedback) === null || _feedbackState$taskFe2 === void 0 ? void 0 : _feedbackState$taskFe2.taskId)]
  });
};

export default TodosPageV2;